import { color, spacer } from 'stylist'
import styled from '@emotion/styled'

export const Capital = styled.span`
  text-transform: capitalize;
`

export const Bold = styled.span`
  font-weight: 500;
`

export const Bolder = styled.span`
  font-weight: 800;
`

export const Faded = styled.span`
  color: ${color('cadet')};
`

export const Pewter = styled.span`
  color: ${color('pewter')};
`

export const Slate = styled.span`
  color: ${color('slate')};
`

export const Ink = styled.span`
  color: ${color('ink')};
`

export const Red = styled.span`
  color: ${color('red')};
`

export const LeftAlign = styled.span`
  text-align: left;
`

export const SubHeading = styled(Bold)`
  color: ${color('ink')};
  margin-bottom: ${spacer(2)};
`



// WEBPACK FOOTER //
// ./src/components/Text.js